import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import store from '../store'
import { setVersion, setTokenKey, setUrlScriptAyuda } from '../actions'

let URL_BASE = 'https://jlmm2gbdu6.execute-api.us-east-1.amazonaws.com/dev'
let URL_SESSION_OPENID =
  'https://e8klvcfqt0.execute-api.us-east-1.amazonaws.com/test/sesion'
let URL_DUMMY = ''

export let url_script_ayuda =
  'https://static.zdassets.com/ekr/snippet.js?key=b3f90d0c-ebfb-4de3-b4b9-7fa276e2bd04'

let version = '2.0'
let tokenKey = 'token_sieda'

store.dispatch(setVersion(version))
store.dispatch(setTokenKey(tokenKey))
store.dispatch(setUrlScriptAyuda(url_script_ayuda))

export async function getRequest(ws, dummy = false, session = false) {
  let token = localStorage.getItem(tokenKey)
  let url
  if (dummy) {
    url = URL_DUMMY
  } else if (session) {
    url = URL_SESSION_OPENID
  } else {
    url = URL_BASE
  }
  let response = await fetch(url + ws, {
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      tk: token,
    },
  })
  let data = await response.json()
  if (data.s !== 'OK') {
    toast.error(data.m)
  }
  if (data.m === 'token no existe' || data.m === 'token expirado') {
    localStorage.removeItem(tokenKey)
    setTimeout(() => {
      window.location.reload()
    }, 2000)
  } else {
    return data
  }
}

export async function postRequest(ws, json = {}, dummy = false) {
  let token = localStorage.getItem(tokenKey)
  let url = dummy ? URL_DUMMY : URL_BASE
  let response = await fetch(url + ws, {
    mode: 'cors',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      tk: token,
    },
    body: JSON.stringify(json),
  })
  let data = await response.json()
  if (data.s !== 'OK') {
    toast.error(data.m)
  }
  if (data.m === 'token no existe' || data.m === 'token expirado') {
    localStorage.removeItem(tokenKey)
    setTimeout(() => {
      window.location.reload()
    }, 5000)
  } else {
    return data
  }
}

export async function postLogin(ws, json = {}) {
  let response = await fetch(URL_BASE + ws, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  })
  let data = await response.json()
  if (data.m === 'token no existe' || data.m === 'token expirado') {
    localStorage.removeItem(tokenKey)
    setTimeout(() => {
      window.location.reload()
    }, 5000)
  } else {
    return data
  }
}

export async function putRequest(url, archivo, type) {
  let response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': type,
      'Content-Disposition': 'attachment',
    },
    body: archivo,
  })
}
